








import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function IncreaseCapitalCompany() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 46) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  // const formPutPartenshipdeed = async (e) => {
  //   e.preventDefault();

  //   // ✅ Check if user is logged in
  //   // if (!token) {
  //   //   alert("Please log in to continue.");
  //   //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
  //   //   navigate('/login'); // 👈 Use this if you're using React Router
  //   //   return;
  //   // }
  //   if (!validateForm()) return;

  //   localStorage.setItem("bookingData", JSON.stringify(newData));

  //     // Navigate to checkout
  //     navigate('/checkout', {
  //        state: {
  //           service: service,

  //        }
  //     });

  // };


  
        const formPutPartenshipdeed = async (e) => {
          e.preventDefault();
      
          if (!validateForm()) return;
      
          try {
              const response = await PartenerSheepDeedService.increaseCapitalCompany(newData);
      
              console.log("API Success:", response);
      
              navigate("/thankyou");
      
              // Optional: reset form
              setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
      
          } catch (error) {
              console.error("API Error:", error);
              alert("Something went wrong!");
          }
      };



const faqList = [
  {
    question: "What is paid-up share capital?",
    answer: "Paid-up share capital is the amount of money a company has received from shareholders in exchange for shares issued to them."
  },
  {
    question: "How is paid-up capital different from authorized capital?",
    answer: "Authorized capital is the maximum capital a company can raise, while paid-up capital is the actual amount received from shareholders."
  },
  {
    question: "Why increase paid-up share capital?",
    answer: "To raise additional funds for business growth, improve creditworthiness, and attract new investors."
  },
  {
    question: "What approvals are required to increase paid-up capital?",
    answer: "Approval from the board of directors and shareholders through a special resolution in a general meeting is necessary."
  },
  {
    question: "How can new shares be issued?",
    answer: "Shares can be issued via rights issue to existing shareholders, private placement, or to new investors."
  },
  {
    question: "What is the timeline to file necessary documents after allotment?",
    answer: "Form PAS-3 must be filed with the Registrar of Companies within 30 days of allotting new shares."
  },
  {
    question: "Are there any stamp duty or fees involved?",
    answer: "Yes, applicable government fees and stamp duties must be paid as per company law and state regulations."
  },
  {
    question: "Does increasing paid-up capital affect shareholding ratios?",
    answer: "Yes, issuing new shares can dilute existing shareholders' percentage ownership unless they subscribe proportionally."
  },
  {
    question: "Can paid-up capital be increased multiple times?",
    answer: "Yes, companies can increase paid-up capital multiple times as per business requirements."
  },
  {
    question: "Do I need professional help to increase paid-up capital?",
    answer: "While not mandatory, professional assistance ensures smooth compliance with legal formalities and documentation."
  }
];



const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};






  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Increase Paid-Up Share Capital of Your Private Limited Company</h1>

                <p className="pdrl-text">Get Increase Paid-Up Share Capital Service for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                <p className="pd-text">Raise funds, boost your company’s working capital, and strengthen your business by increasing the paid-up share capital. DM2Legal  helps you navigate the entire process with ease, ensuring full compliance with the Companies Act, 2013.
</p>

                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">

Paid-up share capital represents the actual amount of money a company has received from its shareholders in exchange for shares allotted to them. Increasing the paid-up capital is a vital step for companies looking to expand operations, invest in new projects, or improve financial stability.

Unlike authorized capital, which is the maximum capital a company can raise, paid-up capital reflects the real invested funds from shareholders.

How to Increase Paid-Up Share Capital:

Board Meeting: The company’s board of directors must approve the proposal to increase paid-up capital by allotting new shares.

Offer of Shares: New shares can be offered to existing shareholders (rights issue), to new investors, or through private placement.

Shareholders’ Approval: Obtain approval from shareholders, usually by passing a special resolution in a General Meeting.

Allotment of Shares: After receiving the money from shareholders, shares are allotted in their name.

Filing with Registrar of Companies: File the necessary forms (e.g., PAS-3) with the RoC within prescribed timelines.

Updating Registers: Update statutory registers like Register of Members and Share Capital Register.

By increasing paid-up capital, your company gains enhanced financial strength, better credibility with banks and investors, and greater capacity for growth.

              </p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Increase-Capital-(Company).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
      <div className="row">
  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon1.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Improved Financial Resources</a></h4>
        <p className="font-f-7">Increase your capital base to fund business expansion and new projects.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon2.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Enhanced Credibility</a></h4>
        <p className="font-f-7">Strengthen your company’s image with a higher paid-up capital.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Better Loan Access</a></h4>
        <p className="font-f-7">Facilitate easier loan approval from banks and financial institutions.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Attract New Investors</a></h4>
        <p className="font-f-7">Issue new shares to bring additional investors on board.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon5.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Regulatory Compliance</a></h4>
        <p className="font-f-7">Ensure your company meets all legal capital requirements.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon6.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Strengthened Market Position</a></h4>
        <p className="font-f-7">Demonstrate financial strength to stakeholders and partners.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/brand6-4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Improved Working Capital</a></h4>
        <p className="font-f-7">Increase liquidity to smoothly manage daily operations.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/work6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Multiple Capital Raising Options</a></h4>
        <p className="font-f-7">Choose from rights issues, private placement, or other methods to raise capital.</p>
      </div>
    </div>
  </div>

  {/* <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon7.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Flexibility for Future Growth</a></h4>
        <p className="font-f-7">Prepare your company for further capital increases as needed.</p>
      </div>
    </div>
  </div> */}
</div>





          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
       <div className="container">
  <div className="row">
    <div className="col-lg-12 text-center">
      <div className="hadding7">
        <div className="space80"></div>
        <h2>Online Registration Procedure</h2>
      </div>
      <div className="partnership-deade-section">
        <div className="space40"></div>

        <ul className="disc-list">
          <li>
            <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
            <span>To keep you risk-free, our team will thoroughly review your submitted documents to identify any errors or discrepancies.</span>
            <svg className="pointer">
              <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
            </svg>
          </li>
          <li>
            <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
            <span>Our experts will assist you in gathering the necessary documents and ensuring compliance with all regulatory requirements.</span>
            <svg className="pointer">
              <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
            </svg>
          </li>
          <li>
            <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
            <span>Assess your company’s capital requirements and obtain approval from the board of directors.</span>
            <svg className="pointer">
              <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
            </svg>
          </li>
          <li>
            <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
            <span>Obtain shareholder approval by conducting a general meeting and passing the necessary resolutions.</span>
            <svg className="pointer">
              <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
            </svg>
          </li>
          <li>
            <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
            <span>Decide on the method of capital increase—rights issue, public offering, or private placement—and ensure complete allotment and timely filing with the authorities.</span>
            <svg className="pointer">
              <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
            </svg>
          </li>
        </ul>

        <div className="space80"></div>
      </div>
    </div>
  </div>
</div>

      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default IncreaseCapitalCompany;

